import { render, staticRenderFns } from "./input.vue?vue&type=template&id=18a27b9b&lang=pug&"
import script from "./input.vue?vue&type=script&setup=true&lang=js&"
export * from "./input.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./input.vue?vue&type=style&index=0&id=18a27b9b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports